import CheckIcon from "@/components/checkIcon";
import { PricingTier } from "@/redux/slices/plan";
import { PeriodicityTranslate } from "@/service/plans";
import { numberToMoney } from "@/utils";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

interface OrderSummaryProps {
  plan: PricingTier;
  onShowCompanies: () => void;
  compact?: boolean;
}

export default function OrderSummary({
  plan,
  onShowCompanies,
  compact,
}: OrderSummaryProps) {
  const navigate = useNavigate();

  if (compact) {
    return (
      <div className="mb-6 rounded-shell border border-checkout-hairline bg-checkout-surface p-1.5 md:hidden">
        <div className="flex items-center justify-between gap-4 rounded-[calc(1.75rem-0.375rem)] bg-checkout-raised px-5 py-4">
          <div className="min-w-0">
            <p className="truncate font-display text-lg font-semibold">
              {plan.name}
            </p>
            <p className="text-sm text-checkout-muted">
              {numberToMoney(plan.price)} / {PeriodicityTranslate[plan.periodicity]}
            </p>
          </div>
          <button
            type="button"
            onClick={() => navigate("/")}
            className="text-checkout-muted transition-colors duration-500 ease-soft hover:text-checkout-fg"
            aria-label="Voltar"
          >
            <FiArrowLeft size={22} />
          </button>
        </div>
      </div>
    );
  }

  return (
    <aside className="hidden h-full min-h-[100dvh] border-l border-checkout-hairline bg-checkout-surface md:flex md:w-[38%] md:flex-col">
      <div className="flex h-full flex-col p-10">
        <div className="flex items-start gap-3">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="mt-1 text-checkout-muted transition-colors duration-500 ease-soft hover:text-checkout-fg"
            aria-label="Voltar"
          >
            <FiArrowLeft size={22} />
          </button>
          <h2 className="font-display text-3xl font-semibold leading-tight">
            {plan.name}
          </h2>
        </div>
        <p className="mt-6 text-base leading-7 text-checkout-muted">{plan.description}</p>
        <ul className="mt-10 flex-1 space-y-3">
          {plan.services.map((service) => (
            <li
              key={service.IdSubscriptionService}
              className="flex items-center gap-3 text-lg"
            >
              <CheckIcon />
              {service.Service.Description}
            </li>
          ))}
        </ul>
        {plan.allCompanies ? (
          <p className="text-sm text-checkout-muted">* Aceito em todas as unidades</p>
        ) : (
          <button
            type="button"
            className="text-left text-sm text-[var(--tenant-accent-color)] underline-offset-4 hover:underline"
            onClick={onShowCompanies}
          >
            * Aceito em algumas unidades
          </button>
        )}
        <p className="mt-6 font-display text-4xl font-semibold">
          {numberToMoney(plan.price)}
          <span className="ml-2 text-xl font-medium text-checkout-muted">
            /{PeriodicityTranslate[plan.periodicity]}
          </span>
        </p>
      </div>
    </aside>
  );
}
